import { Box, Button, Paper, Typography } from '@mui/material'
import shared from '@/components/Settings/settingsShared.module.scss'
import { useIntegrationsModalOptional } from '@/components/IntegrationsModal/IntegrationsModalContext'

/**
 * The empty state used to claim connections were kept "for this browser session
 * until a directory API is available". That API is what fills this list, and it
 * had been for a while — so the copy told users their connections were
 * temporary when they were not, and pointed at a chat connect card that creates
 * nothing. It also left the page with no way to connect anything, which is the
 * state every new account lands in.
 */
export function ConnectionsDirectoryListEmpty() {
  const integrationsModal = useIntegrationsModalOptional()
  return (
    <Paper elevation={0} className={shared.connectionsPaper}>
      <Box className={shared.connectionsEmpty}>
        <Typography variant="body2" className={shared.connectionsEmptyTitle}>
          No applications connected yet
        </Typography>
        <Typography variant="body2" className={shared.connectionsEmptyBody}>
          Connect Gmail, Slack, Notion and others to let DO Chat read and act on your behalf. You
          approve anything that sends or changes something before it happens.
        </Typography>
        {integrationsModal ? (
          <Button
            size="small"
            variant="contained"
            sx={{ mt: 1.5 }}
            onClick={integrationsModal.openIntegrations}
          >
            Browse apps
          </Button>
        ) : null}
      </Box>
    </Paper>
  )
}

export function ConnectionsDirectorySearchEmpty() {
  return (
    <Paper elevation={0} className={shared.connectionsPaper}>
      <Box className={shared.connectionsNoHits}>
        <Typography variant="body2" className={shared.connectionsNoHitsText}>
          No apps match your search.
        </Typography>
      </Box>
    </Paper>
  )
}
